/**
 * Created by HYL.
 * 设备相关api
 */
import * as API from './'

export default {
  deviceCategoryPageList: params => {
    return API.GET('/api/device/category/list', params)
  },
  saveDeviceCategory: params => {
    return API.POST('/api/device/category/save',params)
  },
  updateDeviceCategory: params =>{
    return API.POST('/api/device/category/update',params)
  },
  removeDeviceCategory: id => {
    return API.DELETE('/api/device/category/remove/' + id)
  },
  checkDeviceCategoryCode: params => {
    return API.GET('/api/device/category/checkcode', params)
  },
  // 设备品类下拉列表
  deviceCategoryCombox: params => {
    return API.GET('/api/device/category/combox', params)
  },
  // 供应商设备品类分页列表
  deviceSupplierCategoryPageList: params => {
    return API.GET('/api/device/supplier/category/list', params)
  },
  saveDeviceSupplierCategory: params => {
    return API.POST('/api/device/supplier/category/save',params)
  },
  updateDeviceSupplierCategory: params =>{
    return API.PUT('/api/device/supplier/category/update',params)
  },
  removeDeviceSupplierCategory: id => {
    return API.DELETE('/api/device/supplier/category/remove/' + id)
  },
  checkDeviceSupplierCategoryType: params => {
    return API.GET('/api/device/supplier/category/checktype', params)
  },
  // 供应商设备品类下拉列表
  deviceSupplierCategoryCombox: supplierId => {
    return API.GET('/api/device/supplier/category/combox/' + supplierId)
  },
  // 设备分页列表
  devicePageList: params => {
    return API.GET('/api/device/pagelist', params)
  },
  saveDevice: params => {
    return API.POST('/api/device/insert',params)
  },
  updateDevice: params =>{
    return API.POST('/api/device/update',params)
  },
  removeDevice: id => {
    return API.GET('/api/device/remove/' + id)
  },
  checkDevice: params => {
    return API.GET('/api/device/checkDevice', params)
  },
  //详情
  deviceDetail:params=>{
    return API.GET("/api/device/getDetail",params)
  },
  //设备变更记录
  deviceChangeLog:params=>{
    return API.GET('/api/deviceChange/allList',params)
  },
  downloadTemplate: params=> {
    return API.DOWNLOAD('/api/device/downloadTemplate', params)
  },
  exportDevice: params => {
    return API.DOWNLOAD('/api/device/exportDevice', params)
  },
  //设备供应商
  allSupplier:params=>{
    return API.GET('/api/deviceSupplier/allList',params)
  },
  //注册设备
  registDevice:deviceId=>{
    return API.GET('/api/device/registDevice/'+deviceId)
  },
  //添加子设备
  insertHostOrPint: params => {
    return API.POST('/api/device/insertHostOrPint',params)
  },
  //修改子设备
  editHostOrPoint: params => {
    return API.POST('/api/device/editHostOrPoint',params)
  },
  //删除子设备
  removeHostOrPoint: id => {
    return API.DELETE('/api/device/removeHostOrPoint/' + id)
  },
  userTransList: params => {
    return API.GET('/api/device/userTrans/list',params)
  },
  //查询主机和点位
  getHostPointList: params =>{
    return API.GET('/api/device/getHostPointList',params)
  },
  //用传设备主机号、回路号、点位号是否重复
  checkUserTrans: params => {
    return API.GET('/api/device/userTrans/checkUserTrans',params)
  },
  downloadPointTemplate: params=> {
    return API.DOWNLOAD('/api/device/downloadPointTemplate', params)
  },
  deviceMap: params => {
    return API.POST('/api/device/deviceMap',params)
  },
  deviceMapMarker: params => {
    return API.POST('/api/device/deviceMapMarker',params)
  },
}



// WEBPACK FOOTER //
// ./src/api/api_device.js